import {API_URL, jsonHeaders} from "./index";

export async function apiGetMoodsToday(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}/moods/today`, {
        headers: jsonHeaders()
    });
    return res.json();
}

export async function apiSubmitMood(groupId, moodLevel) {
    const res = await fetch(`${API_URL}/groups/${groupId}/moods`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({mood_level: moodLevel})
    });
    return res.json();
}
